import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
  HttpClient,
  HttpHeaders,
} from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RatingService {

  private endpoint = environment.endpoint;
  private url = this.endpoint;
  private urlCarga = environment.cargaendpoint
  token: any;

  constructor(private httpclient: HttpClient,) {
    this.token = localStorage.getItem('authToken')
    // // console.log(this.token)
  }

  create(info) {

    const url = this.urlCarga + '/custom-carga/review';

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.token,
      })
    };

    return this.httpclient.post(url, info, httpOptions);
  }

  getRating(id) {

    const url = this.urlCarga + '/custom-carga/review/rated-user/' + id;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.token,
      })
    };

    return this.httpclient.get(url, httpOptions);
  }
  
}
